<template>
  <div>
    <b-modal
      ref="modal"
      no-close-on-backdrop
      title="Lançamento no caixa"
      header-class="border-bottom-0"
      size="xs"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <select-input v-model="form.type.value" :alias="'Tipo'" :options="form.type.options"/>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <text-input
              :alias="form.description.alias"
              v-model="form.description.value"
            />
          </div>
        </div>
        

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Historico:</label>
              <textarea
                v-model="form.history.value"
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <account-plan-search
              @accountPlanSelected="setAccountPLan($event)"
            />
          </div>
        </div>

        <div class="row" v-if="canChangeDate">
          <div class="col-md-12">
            <date-input v-model="form.paid_at.value" :alias="'Data'" />
          </div>
        </div>

        <div class="row">
        
          <div class="col">
            <number-input v-model="form.value.value" :alias="'Valor'" />
          </div>
        </div>
      </div>

      <br />

      <error-handler :error="error" />
      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
        >{{ alertData.message }}</b-alert
      >

      <!-- form  -->

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
          v-if="isInsert"
        >
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "../../../mixins/Form.js";
import moment from "moment";
import OderPayments from "../../sections/OrderPayments.vue";
import ClientSearch from "../../ClientSearch";
import accountPlanSearch from "../search/accountPlanSearch";

export default {
  components: {
    OderPayments,
    ClientSearch,
    accountPlanSearch,
  },

  props: {
    accountPlanOptions: {},
  },

  data: function () {
    return {
      form: new Form({
        id: {
          default: null,
        },
        // todo change for person
        person_id: {
          alias: "Cliente",
        },

        name: {},

        description: {
          alias: "Descrição",
          validate: {
            required: true,
          },
        },

        history: {},

        account_plan_id: {
          alias: "Plano de Contas",
          validate: {
            required: true,
          },
        },

        account_plan_name: {},

        paid_at: {
          value: null,
          default : moment().format("YYYY-MM-DD"),
        },

        type: {
          alias: "Tipo",
          validate: {
            required: true,
          },
          options: {
            i: "Entrada",
            o: "Saida",
          },
        },

        value: {
          Alias: "R$ Valor",
          validate: {
            required: true,
          },
        },

        account_id: {},
      }),

      accountplan: {},

      selectedPerson: null,

      selectedAccountPlan: null,

      searchPersonResults: {
        results: {},
        isLoading: false,
      },

      searchAccountPlanResults: {
        results: {},
        isLoading: false,
      },

      error: null,

      alertData: {
        isVisible: false,
        message: null,
      },
    };
  },

  computed: {
    isInsert() {
      return this.form.id.value == null || this.form.id.value == "";
    },

    account() {
      return this.$store.getters['account/selectedAccount']
    },

    canChangeDate() {
      return (this.$store.getters['account/selectedAccount'].type !== 'd')
    }
  },

  methods: {
    open(account_id, accountTransactionId = null) {
      this.resetForm();

      this.form.account_id.value = account_id;

      if (accountTransactionId) {
        this.selectAccountTransaction(accountTransactionId);
      } else {
        this.$refs.modal.show();
      }
    },

    setPerson(person) {
      this.selectedPerson = person;

      this.form.person_id.value = person.id;

      this.form.name.value = person.name;
    },

    setAccountPLan(accountplan) {
      this.selectedAccountPlan = accountplan;

      this.form.account_plan_id.value = accountplan.id;

      this.form.account_plan_name.value = accountplan.description;
    },

    resetForm() {
      this.error = null;

      this.alertData.isVisible = false;

      this.form.reset();
    },

    store() {
      this.alertData.isVisible = false;

      if (this.form.isValid()) {
        this.$store.commit("showLoading");
        this.$store
          .dispatch(
            "accountTransaction/storeAccountTransaction",
            this.form.getValues()
          )
          .then((response) => {
            this.processSuccess();

            return;
          })
          .catch((error) => {
            this.error = error;

            this.$store.commit("hideLoading");

            return;
          });
      } else {
        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;
      }
    },

    processSuccess() {
      this.$refs.modal.hide();

      this.$emit("stored");
    },
  },
};
</script>
